import React from "react";

import SharedModalContext from "contexts/SharedModalContext";

const useSharedModalContext = () => React.useContext(SharedModalContext);

export default useSharedModalContext;
